<template>
  <div class="container">
    <div class="row">
      <div class="col-sm">
        <div class="box-bordered p-l-10 p-r-10 p-b-10">
          <table width="100%">
            <tbody>
            <PrintList
                v-for="user in users"
                :children="user.children"
                :user="user.user"
            >
            </PrintList>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {backend} from "../../backend.js";
import Vue from 'vue';
import Vuesax from 'vuesax';
import PrintList from './StructurePrintList.vue'

Vue.use(Vuesax);

export default {
  name: "Structure",
  props: ['children', 'user'],
  components: {
    PrintList
  },
  data() {
    return {
      users: []
    }
  },
  created() {
    this.showUsers()
  },
  methods: {
    showUsers: function () {
      return backend.getStructure()
          .then(response => {
            this.users = response.data;
            console.log(this.users);
          })
          .catch(() => {
            this.$vs.notify({text: 'Nie udało się pobrać listy pracowników', color: 'danger'});
          });
    },
  },
}
</script>


// WEBPACK FOOTER //
// Structure.vue?41a55401